module.exports = __webpack_public_path__ + "img/Screenshot_optios_main.e4de94ef.png";